export const MEMBER_ACTIVITY_PATH = '/home/memberactivity';
